/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Button, Input, Label, Modal, InputCheckbox, Pagination, CustomLoading, SaveIcon } from "../../../Components";

/* 🔗 SERVICE */
import { PermissionsServices } from "../../../Services/permissoesServices";

/* 🧠 REDUX */
import { store } from "../../../Redux/Store";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { changeModal } from "../../../Redux/Actions";

/* 📁 ASSETS*/
import { Lupa } from "../../../Assets/icons";

/* 🎨 STYLES */
import { Container, CountContainer, LineTitle, TitleText, LineList, ListText, ContainerList, HeaderContainer, InputContainer, 
    FilterInput, ContainerHead, ContainerRow, ButtonsContainer, ContainerColumn, ContentHeader } from "./styles";

/* 🔧 UTILS */
import { isValidField } from "../../../util/validate";

const ListPermissions = () => {
    // const navigate = useNavigate();
    const { t } = useTranslation();

    document.title = t("administrative.sub-items.permissions.list.document-title");
    
    const [permissions, setPermissions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    
    const Services = useRef(new PermissionsServices());
    const searchValue = useRef();
    
    const TitleField = useRef();
    const DescriptionField = useRef();
    const PermissionField = useRef();
    
    const TitleValue = useRef('');
    const DescriptionValue = useRef('');
    const PermissionValue = useRef('');
    
    const PrivateValue = useRef(false);
    
    const user = useSelector(state => state.userReducer);
    let active = useSelector(state => state.ModalReducer.name);
    
    // Pega todas as permissões
    const getPermissions = async() => {
        setIsLoading(true);
        let currentPermissions = await Services.current.getAllPermissions('');
        setPermissions(currentPermissions);
        setIsLoading(false);
    }

    useEffect(() => {
        getPermissions();
    }, []);

    // Salva as edições do usuário
    const Save = async() => {
        store.dispatch(changeModal(''))
        if(isValidField(TitleValue.current) && isValidField(DescriptionValue.current) && isValidField(PermissionValue.current) && isValidField(PrivateValue)){
            let form = new FormData();
            if(TitleValue.current){form.append('title', TitleValue.current)};
            if(DescriptionValue.current){form.append('description', DescriptionValue.current)};
            if(PermissionValue.current){form.append('permission', PermissionValue.current)};
            form.append('is_private', PrivateValue.current ? 1 : 0);
    
            await Services.current.savePermission(form);
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    const changePage = async(page) => {
        setIsLoading(true);
        let currentPermissions = await Services.current.getAllPermissions(searchValue.current, page);
        setPermissions(currentPermissions);
        setIsLoading(false);
    }

    const aplyFilter = async() =>{
        setIsLoading(true);
        let currentPermissions = await Services.current.getAllPermissions(searchValue.current);
        setPermissions(currentPermissions);
        setIsLoading(false);
    }
    
    return(
        <>
            <Container>

                <HeaderContainer>
                    <ContentHeader>
                        <InputContainer>
                            <img src={Lupa} alt={t("inputs.search-permission.alt")}></img>
                            <FilterInput
                                // onBlur={()=>Aplyfilter()}
                                onKeyDown={(e) => e.key === 'Enter' && aplyFilter()}
                                onChange={(e) => searchValue.current = e.target.value}
                                placeholder={t("inputs.search-permission.placeholder")}
                            />
                        </InputContainer>

                        <Button width={'fit-content'} text={t("buttons.apply")} onClick={() => aplyFilter()}></Button>
                    </ContentHeader>
                </HeaderContainer>
                
                <ContainerHead>
                    <CountContainer>
                        {t("administrative.sub-items.list-total") + " " + permissions?.meta?.total + " " + t("administrative.sub-items.permissions.list.equipments")} 
                    </CountContainer>
                    {user?.user?.can?.includes('permission.create') ?
                        <Button onClick={() => store.dispatch(changeModal('newPermission'))} width={'fit-content'} icon={''} text={t("buttons.register-permission")}></Button>
                    : <></>}
                </ContainerHead>

                <ContainerList>
                    <LineTitle>
                        <TitleText>{t("header-table.title")}</TitleText>
                        <TitleText>{t("header-table.description")}</TitleText>
                        <TitleText></TitleText>
                    </LineTitle>
                    {isLoading?
                        <CustomLoading width={'150px'} height={'150px'}/>
                    :
                        permissions?.data?.map((item) => (
                            <LineList key={item.id} href={user?.user?.can?.includes('permission.view') ? `/adm/permissoes/${item.id}` : undefined}>
                                <ListText>{item.title}</ListText>
                                <ListText>{item.description}</ListText>
                                <ListText></ListText>
                            </LineList>
                        ))
                    }
                </ContainerList>

                {isLoading ?
                    <></>
                : <Pagination last_page={permissions?.meta?.last_page} currentpage={permissions?.meta?.current_page} changepage={changePage}/>}

            </Container>
             <Modal title={t("modal.register-permission.title")} name={'newPermission'} width={'40%'} height={'85%'} >           
                {active === 'newPermission' ?
                    <>
                        <ContainerRow onSubmit={(e) => e.preventDefault()}>
                            <ContainerColumn>
                                <Label text={t("inputs.title.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='title' 
                                    name='title' 
                                    type="text" 
                                    placeholder={t("inputs.title.placeholder")}
                                    innerRef={TitleField}
                                    invalidMessage={t("inputs.title.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => TitleValue.current = text}> 
                                </Input>

                                <Label text={t("inputs.description.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='description' 
                                    name='description' 
                                    type="text" 
                                    placeholder={t("inputs.description.placeholder")}
                                    innerRef={DescriptionField}
                                    invalidMessage={t("inputs.description.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => DescriptionValue.current = text}> 
                                </Input>

                                <Label text={t("inputs.permission.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='permission' 
                                    name='permission' 
                                    type="text" 
                                    placeholder={t("inputs.permission.placeholder")}
                                    innerRef={PermissionField}
                                    invalidMessage={t("inputs.permission.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => PermissionValue.current = text}> 
                                </Input>

                                <InputCheckbox text={t("checkbox.is-private")} onChange={(value)=> {
                                    PrivateValue.current = value;
                                    return true;
                                }}/>
                            </ContainerColumn>
                        </ContainerRow>

                        <ButtonsContainer>
                            <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={() => Save()}/>
                            <Button text={t("buttons.cancel")} width={'150px'} color={'white-red'} onClick={() => store.dispatch(changeModal(''))}/>
                        </ButtonsContainer>
                    </>
                :<></>}
            </Modal>
        </>
    )
}

export default ListPermissions ;